import './dropdown.scss'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

const Dropdown = ({
  value,
  label,
  onChange,
  name,
  options,
  isLocked,
  onUnlock,
}) => {
  const inputDisabled = isLocked
  const inputValue = value === null ? '' : value

  function handleChange(evt) {
    onChange(evt.target.value)
  }
  return (
    <div className="dropdown">
      <label htmlFor={name}>{label}</label>
      <div className="relative">
        <select
          value={inputValue}
          onChange={handleChange}
          name={name}
          id={name}
          disabled={inputDisabled}
        >
          {isLocked && <option value="">mixed</option>}
          {options.map((option) => (
            <option value={option.id} key={option.id}>
              {option.name}
            </option>
          ))}
        </select>
        {isLocked && (
          <div className="absolute top-0 right-0 ">
            <button
              className="bg-gray-light b-0 border-0 h-[37px] w-[35px] flex items-center justify-center rounded-r"
              onClick={onUnlock}
            >
              <EditIcon height="20" width="20" fill="#ccc" />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Dropdown
